import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MonitoredJob } from './monitored-job';

@Injectable({ providedIn: 'root' })
export class JobMonitoringService {

	constructor(private http: HttpClient) { }

	public getJobs(): Observable<Array<MonitoredJob>> {
		return this.http.get<MonitoredJob[]>('rest/jobmanager/monitoring')
			.pipe(map(jobs => jobs.map(job => ({
				...job,
				triggeredAt: new Date(job.triggeredAt),
				startedAt: job.startedAt ? new Date(job.startedAt) : null,
				endedAt: job.endedAt ? new Date(job.endedAt) : null,
			}))));
	}
} 